/* eslint-disable no-underscore-dangle */
interface Trap {
  id: string;
  priority: number;
  isActive: boolean;
  isPaused: boolean;
}

type Listener = (traps: Trap[]) => void;

declare global {
  interface Window {
    __FOCUS_TRAPS__?: {
      traps: Trap[];
      listeners: Listener[];
      registerTrap: (id: string, priority: number) => void;
      unregisterTrap: (id: string) => void;
      updateActiveTrap: () => void;
      notifyListeners: () => void;
      subscribe: (listener: Listener) => () => void;
      pauseAllTraps: () => void;
      resumeAllTraps: () => void;
      resolveExternalConflict: () => void;
      isElementWithinTrap: (element: Element | null, trapId: string) => boolean;
    };
  }
}

if (!window.__FOCUS_TRAPS__) {
  window.__FOCUS_TRAPS__ = {
    traps: [],
    listeners: [],

    registerTrap(id: string, priority: number) {
      this.traps.push({ id, priority, isActive: false, isPaused: false });
      this.traps.sort(
        (a: { priority: number }, b: { priority: number }) =>
          b.priority - a.priority
      );
      this.updateActiveTrap();
      this.notifyListeners();
    },

    unregisterTrap(id: string) {
      this.traps = this.traps.filter((trap: { id: string }) => trap.id !== id);
      this.updateActiveTrap();
      this.notifyListeners();
    },

    updateActiveTrap() {
      if (this.traps.length === 0) return;
      const activeTrapId = this.traps[0].id;
      this.traps = this.traps.map((trap: { isPaused: any; id: string }) => ({
        ...trap,
        isActive: trap.id === activeTrapId && !trap.isPaused
      }));
    },

    notifyListeners() {
      this.listeners.forEach((listener: (arg0: any) => any) =>
        listener(this.traps)
      );

      // Remove focus listener if no traps are active
      /*      if (this.traps.length === 0) {
        document.removeEventListener('focus', focusListener, true);
      } */
    },

    subscribe(listener: Listener): () => void {
      this.listeners.push(listener);
      return () => {
        this.listeners = this.listeners.filter((l: Listener) => l !== listener);
      };
    },

    pauseAllTraps() {
      this.traps = this.traps.map((trap: Trap) => ({
        ...trap,
        isPaused: true,
        isActive: false
      }));
      this.notifyListeners();
    },

    resumeAllTraps() {
      this.traps = this.traps.map((trap: Trap) => ({
        ...trap,
        isPaused: false
      }));
      this.updateActiveTrap();
      this.notifyListeners();
    },

    resolveExternalConflict() {
      // Pause all plugin traps to prioritize external focus traps
      this.traps.forEach((trap: { isActive: boolean }) => {
        if (trap.isActive) {
          trap.isActive = false;
        }
      });

      this.updateActiveTrap();
      this.notifyListeners();
    },

    isElementWithinTrap(element: Element | null, trapId: string): boolean {
      const trapContainer = document.querySelector(
        `[data-trap-id="${trapId}"]`
      );
      return trapContainer?.contains(element) ?? false;
    }
  };

  // Monitor focus changes to detect external traps
  /*  const focusListener = () => {
    const { activeElement } = document;

    // Check if the active element is outside all plugin traps
    const isOutsidePlugin = !window.__FOCUS_TRAPS__.traps.some(
      (trap) =>
        trap.isActive &&
        window.__FOCUS_TRAPS__.isElementWithinTrap(activeElement, trap.id)
    );

    if (isOutsidePlugin) {
      console.warn(
        'Focus moved outside the plugin context. Resolving external conflict.'
      );
      console.log(activeElement);
      window.__FOCUS_TRAPS__.resolveExternalConflict();
    }
  };

  document.addEventListener('focus', focusListener, true); */
}

export default window.__FOCUS_TRAPS__;
